export default "__VITE_ASSET__Cv7C449g__"